<template>
  <Select
    class="beneficiary-selector__select"
    :placeholder="placeholder"
    :value="selectedPrivilegeId"
    :options="privileges"
    :empty-text="emptyStateText"
    value-key="id"
    label-key="label"
    :is-disabled="isDisabled"
    @beforeChange="onBeforeChange"
    @change="onPrivilegeSelect"
  >
    <template #option="{ option }">
      <p v-if="option" class="beneficiary-selector-option__info-text">
        {{ option.label }}
      </p>
    </template>
  </Select>
</template>

<script>
import { Select } from '@/shared/ui/form';

export default {
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      type: [String, Object],
      default: null,
    },
    placeholder: {
      type: String,
      default: 'Виберіть привілей',
    },
    privilege: {
      type: [String, Number, Object, null],
      default: null,
    },
    privileges: {
      type: Array,
      default: () => [],
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    emptyStateText: {
      type: String,
      default: 'Нічого немає',
    },
  },
  data() {
    return {
      selectedPrivilegeId: null,
    };
  },
  mounted() {
    this.initializeSelection();
  },
  components: { Select },
  methods: {
    initializeSelection() {
      if (this.value) {
        const valueId = typeof this.value === 'object' ? this.value?.id : this.value;
        if (this.findPrivilegeById(valueId)) {
          this.onPrivilegeSelect(valueId);
          return;
        }
      }

      if (this.privilege) {
        const beneficiaryId = typeof this.privilege === 'object' ? this.privilege?.id : this.privilege;
        if (this.findPrivilegeById(beneficiaryId)) {
          this.onPrivilegeSelect(beneficiaryId);
          return;
        }
      }

      if (this.privileges?.length === 1) {
        this.onPrivilegeSelect(this.privileges[0]?.id);
      }
    },

    findPrivilegeById(id) {
      return this.privileges.find(privilege => privilege?.id === id);
    },

    onPrivilegeSelect(selectedId) {
      this.selectedPrivilegeId = selectedId;
      const selectedPrivilege = this.findPrivilegeById(selectedId);
      this.$emit('input', selectedPrivilege);
      this.$emit('change', selectedPrivilege);
      this.$emit('beneficiary-selected', selectedPrivilege);
    },
    onBeforeChange(newValue, oldValue) {
      this.$emit('beforeChange', newValue, oldValue);
    },
  },
  watch: {
    value: {
      handler(newValue, oldValue) {
        if (oldValue !== newValue && newValue) {
          const valueId = typeof newValue === 'object' ? newValue?.id : newValue;
          if (this.findPrivilegeById(valueId)) {
            this.onPrivilegeSelect(valueId);
          }
        }
      },
    },
    privilege: {
      handler(newValue, oldValue) {
        if (oldValue !== newValue && newValue) {
          const beneficiaryId = typeof newValue === 'object' ? newValue?.id : newValue;
          if (this.findPrivilegeById(beneficiaryId)) {
            this.onPrivilegeSelect(beneficiaryId);
          }
        }
      },
    },
    privileges: {
      handler() {
        if (!this.selectedPrivilegeId || !this.findPrivilegeById(this.selectedPrivilegeId)) {
          this.initializeSelection();
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.beneficiary-selector__select {
  width: 100%;
}

.beneficiary-selector-option__info-text {
  margin: 0;

  &:not(:last-child) {
    margin-bottom: 4px;
  }

  strong {
    font-weight: 600;
  }
}
</style>
